import { Building } from "lucide-react";
import { INDUSTRIES } from "@/data/content";

export const Industries = () => {
  return (
    <section data-testid="industries-section" className="py-24 sm:py-32 bg-[#1c4f9c] relative overflow-hidden">
      <div className="absolute inset-0 grain-overlay opacity-[0.08]" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#ff6b70] mb-3">Industries We Serve</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-white">
            Trusted across every commercial environment
          </h2>
          <p className="mt-4 text-base text-blue-100/80">
            From corporate offices to medical facilities and industrial properties — we tailor our programs to your industry's standards.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {INDUSTRIES.map((ind, i) => (
            <div
              key={ind}
              data-testid={`industry-${i}`}
              className="flex items-center gap-3 bg-white/5 border border-white/10 px-5 py-4 rounded-sm hover:bg-white/10 hover:border-[#ff6b70]/50 transition-colors duration-200"
            >
              <Building size={18} className="text-[#ff6b70] shrink-0" />
              <span className="text-sm font-semibold text-white">{ind}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
